// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"6295":"9d78c252","7388":"63d2ba32"}[chunkId] || chunkId) + "." + {"1704":"54eeafc1f7323da4","3541":"38f00b8b2de3cea5","3672":"935f754abeae5814","6295":"e4b028f7b3760c72","7388":"acf66e48af50439e"}[chunkId] + ".js";
};